import store from '../redux/store';

export const getCurrency = () => {
  return store?.getState()?.coin?.moneda?.toLocaleUpperCase() ?? '';
};
